import {AngularFirestore, Query, QuerySnapshot} from '../../../node_modules/angularfire2/firestore/index';
import {firestore} from 'firebase';
import {Injectable} from '@angular/core';

@Injectable()
export class EventService {
  constructor(private db: AngularFirestore) {
    console.log('creating event service');
  }

  selectedEvent: EventDto;

  fetchEvents(userId: String, eventType: String): Promise<EventDto[]> {
    const users: firestore.CollectionReference = this.db.firestore.collection('users');
    const today: Date = new Date();
    const promise = new Promise<EventDto[]>((resolve, reject) => {
      const url = `/users/${userId}/events`;
      const eventCollection: Query = this.db.firestore
        .collection(url)
        .where('eventType', '==', eventType)
        .where('eventEndDate', '>=', today)
        .where('removed', '==', false);
      return eventCollection.get()
        .then((snapshot: QuerySnapshot<EventDto>) => {
          return resolve(snapshot.docs.map((doc) => {
            // console.dir(doc);
            return {... doc.data(), id: doc.id, eventStartDate: doc.data().eventStartDate.toDate()};
          }));
        }).catch((error) => {
          reject(error);
        });
    });
    return promise;
  }
}

export interface EventDto {
  id: String;
  discountCode?: string;
  discountPrice?: number;
  description: String;
  eventAddress: String;
  eventStartDate: any;
  eventEndDate: any;
  eventType: String;
  eventName: String;
  removed: boolean;
  totalPrice: number;
  media?: {
    image?: string,
    youtube?: string
  };

}
